import React, { useState } from 'react';
import { history, useDispatch, getLocale, useIntl } from 'umi';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import MetricsTable from './MetricsTable/Page';
import PCU from './PCU';
import DigitalRevenue from './DigitalRevenue';
import PhysicalRevenue from './PhysicalRevenue';
import MAU from './MAU';
import LifetimePlayers from './LifetimePlayers';
import NewRelease from './NewRelease';
import Upcoming from './Upcoming';
import SteamSales from './SteamSales';
import { LANGUAGE_CN } from '@intelligence/_config/config';
import { DBI_TOPCHARTS } from '@intelligence/models/topcharts';

import '@intelligence/assets/scss/TopCharts/PCGames/index.scss';

const { Content } = Layout;

const METRICS_TABLE_TAB_ID = 'MetricsTable';

const PCGames: React.FC<any> = (props) => {
  const { match } = props;

  const locale = getLocale();
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [activeId, setActiveId] = useState(match?.params?.tab || METRICS_TABLE_TAB_ID);

  const tabs = [
    {
      id: METRICS_TABLE_TAB_ID,
      label: formatMessage({ id: `dbi_metrics_table` }),
      component: <MetricsTable />,
    },
    { id: 'PCU', label: formatMessage({ id: `dbi_pcu` }), component: <PCU /> },
    {
      id: 'DigitalRevenue',
      label: formatMessage({ id: `dbi_digital_revenue` }),
      component: <DigitalRevenue />,
    },
    {
      id: 'PhysicalRevenue',
      label: formatMessage({ id: `dbi_physical_revenue` }),
      component: <PhysicalRevenue />,
    },
    {
      id: 'SteamSales',
      label: <div className="dbi-tab-flex">{formatMessage({ id: `dbi_steam_sales` })}</div>,
      component: <SteamSales />,
    },
    { id: 'MAU', label: formatMessage({ id: `dbi_mau` }), component: <MAU /> },
    {
      id: 'LifeTimePlayers',
      label: formatMessage({ id: `dbi_lifetime_players` }),
      component: <LifetimePlayers />,
    },
    {
      id: 'NewRelease',
      label: formatMessage({ id: `dbi_new_release` }),
      component: <NewRelease />,
    },
    {
      id: 'Upcoming',
      label: formatMessage({ id: `dbi_upcoming` }),
      component: <Upcoming />,
    },
  ];

  const handleNavigate2PCConsoleGames = (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e?.stopPropagation();
    e?.preventDefault();
    history.push('/intelligence/topCharts/pcConsoleGames');
  };

  return (
    <Content className="dbi-topcharts-pc">
      <Content.Header
        className="contentHead-normal"
        title={
          <div className="dbi-topcharts-pc__header-title">
            <div className="dbi-topcharts-pc__header-title-left">{formatMessage({ id: `dbi_pc_games` })}</div>
            {activeId === METRICS_TABLE_TAB_ID && (
              <div className="dbi-topcharts-pc__header-title-right">
                {locale === LANGUAGE_CN ? (
                  <>
                    更多游戏指标可在<a onClick={handleNavigate2PCConsoleGames}>端游 & 主机游戏</a>页面查看
                  </>
                ) : (
                  <>
                    For more game metrics, please refer to{' '}
                    <a onClick={handleNavigate2PCConsoleGames}>PC & Console Games</a>
                  </>
                )}
              </div>
            )}
          </div>
        }
      >
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="TopChartsPCGames"
            animated={false}
            tabs={tabs}
            activeId={activeId}
            onActive={(tab) => {
              const { id: tabId } = tab || {};
              setActiveId(tabId);
              dispatch({ type: `${DBI_TOPCHARTS}/setMetricValue`, payload: '' });
              dispatch({ type: `${DBI_TOPCHARTS}/setMetricCurName`, payload: '' });
              history.replace(`/intelligence/topCharts/pcGames/${tabId}`);

              setLoading(true);
              setTimeout(() => {
                setLoading(false);
              }, 0);
            }}
          />
        </div>
      </Content.Header>
      <Content.Body full>
        {!loading &&
          tabs?.map((tab) => {
            const { id: tabId, component: tabComponent } = tab || {};
            if (tabId !== activeId || !tabComponent) return null;
            return <div key={tabId}>{tabComponent}</div>;
          })}
      </Content.Body>
    </Content>
  );
};

export default PCGames;
